(function() {
  var cartContainer = document.getElementById("CartContainer");
  var checkout = document.getElementsByName('checkout')[0];

  var idme = `<div class="idme">
    <div class="idme-shopify">
      <p class='idme-btn-affinity'>Military (US & CAN), First Responders (US & CAN) and Government Employees (US) receive a 10% discount. The discount will be applied automatically at checkout. Please verify your eligibility with ID.me.</p>
      <a class="idme-btn-unify" href="javascript:void(0)" onclick="idmePopUp()">
        <img src="https://cdn.shopify.com/s/files/1/0430/4443/8181/files/idme_button_FDE.png?v=1671483913" alt="ID.me" style="height:42px"/>
      </a>
    </div>
  </div>`;


  checkout && checkout.insertAdjacentHTML("afterend", idme);
})();

function idmePopUp() {
  var body = document.body;
  var html = document.documentElement;

  var height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
  var width = Math.max( body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth );

  var top   = (height - 780) / 4;
  var left  = (width - 800) / 2;

  window.open("https://discountify.id.me/oauth/checkpoint/gbrs-group-gear", "", "scrollbars=yes,menubar=no,status=no,location=no,toolbar=no,width=800,height=780,top=" + top + ",left=" + left);
};

var urlParams = new URLSearchParams(window.location.search)

if (urlParams.get('popup')) {
  if (window.opener) {
    window.opener.location.href = "https://gbrs-group-gear.myshopify.com/checkout";
  	window.close();
  }
  else {
  	window.location.href = "https://gbrs-group-gear.myshopify.com/checkout";
  }
};

if (urlParams.get('error')) {
  window.close();
};

